import { useState } from "react";

import { allTrackers } from "app/services/track/track";

interface IUseSidePanelWrapperConfig {
    analyticsLabel: string;
}

interface IUseSidePanelWrapperReturn<T> {
    isOpen: boolean;
    selectedRow: T | undefined;
    openSidePanel: (row: T) => void;
    closeSidePanel: () => void;
}

export const useSidePanelWrapper = <T = unknown>(config: IUseSidePanelWrapperConfig): IUseSidePanelWrapperReturn<T> => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [selectedRow, setSelectedRow] = useState<T | undefined>(undefined);

    const openSidePanel = (row: T): void => {
        setSelectedRow(row);
        setIsOpen(true);
        allTrackers.dispatchTrackEvent("Button", "click", config.analyticsLabel);
    };

    const closeSidePanel = (): void => {
        setIsOpen(false);
        setSelectedRow(undefined);
    };

    return {
        isOpen,
        selectedRow,
        openSidePanel,
        closeSidePanel,
    };
};
